// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs-container":"Breadcrumbs_breadcrumbs-container__30Ldf","breadcrumbs-item-link":"Breadcrumbs_breadcrumbs-item-link__dvvrN"};